import React from 'react';
import { WifiOff } from 'lucide-react';
import { useOnlineStatus } from '../hooks/useOnlineStatus';
import './OfflineBanner.css';

/** Fixed top banner shown whenever the browser loses network connectivity. */
const OfflineBanner: React.FC = () => {
  const isOnline = useOnlineStatus();
  if (isOnline) return null;

  return (
    <div className="offline-banner" role="status">
      <WifiOff size={14} strokeWidth={2} aria-hidden="true" />
      <span>No internet connection. Changes won't be saved until you're back online.</span>
    </div>
  );
};

export default OfflineBanner;
